<template>
  <div class="wrap">
    <div class="carTop">
      <van-sticky>
        <van-nav-bar title="我的订单" @click-right="delCart()" />
      </van-sticky>
      <!-- 订单分类 -->
      <van-tabs
        v-model="typeActive"
        title-active-color="#3B6BFB"
        title-inactive-color="#666666"
      >
        <van-tab v-for="(item, index) in typeList" :key="index">
          <div class="tab-title" slot="title" @click="changeType(item, index)">
            {{ item.label }}
          </div>
        </van-tab>
      </van-tabs>
      <van-tabs
        v-if="typeActive == 0"
        v-model="active"
        title-active-color="#3B6BFB"
        title-inactive-color="#666666"
      >
        <van-tab v-for="(item, index) in arrPersonal" :key="index">
          <div
            class="tab-title"
            slot="title"
            @click="changePerson(item, index)"
          >
            {{ item.label }}
          </div>
        </van-tab>
      </van-tabs>
      <van-tabs
        v-if="typeActive == 1"
        v-model="active"
        title-active-color="#3B6BFB"
        title-inactive-color="#666666"
      >
        <van-tab v-for="(item, index) in arrTeam" :key="index">
          <div class="tab-title" slot="title" @click="changeTeam(item, index)">
            {{ item.label }}
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 主体内容 -->
    <div class="conWrap">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="沒有更多了"
        @load="onLoad"
        class="listWrap"
        v-if="typeActive == 0"
      >
        <van-checkbox-group @change="getresult" v-model="result">
          <div
            v-for="(item, index) in listData"
            :key="index"
            class="order-item-wrapper"
          >
            <div>
              <div class="order-header">
                <div style="color: #3b6bfb">订单号:{{ item.order_num }}</div>
                <div
                  class="orderStatus"
                  v-show="
                    item.status == 1 || item.status == 2 || item.status == 3
                  "
                >
                  进行中
                </div>
                <div class="orderStatus" v-show="item.status == 4">已发货</div>
                <div class="orderStatus" v-show="item.status == 5">已取消</div>
              </div>
              <div class="order-body" @click="goDetails(item)">
                <div class="order-body-pic">
                  <van-image :src="item.image"></van-image>
                </div>
                <div class="order-body-info">
                  <div style="margin: 8px 0">
                    <div>{{ item.goods_name }}</div>
                    <div></div>
                  </div>
                  <div style="margin: 8px 0">
                    <div style="color: #999999">{{ item.attributes }}</div>
                    <div></div>
                  </div>
                  <div class="order-body-info-name">
                    <div style="color: #f95822">￥{{ item.price }}</div>
                    <div>*{{ item.nums }}</div>
                  </div>
                  <div style="display:flex;justify-content:space-between">
                    <div></div>
                    <div>
                      快递:
                      {{ item.freight }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="order-body-info-num">
              <div>下单时间:{{ item.create_time }}</div>
              <div>小计:{{ item.total_price }}</div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
      <!-- 团队订单 -->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="沒有更多了"
        @load="onLoadTeam"
        class="listWrap"
        v-if="typeActive == 1"
      >
        <van-checkbox-group @change="getresult" v-model="result">
          <div
            class="order-item-wrapper"
            v-for="(item, index) in listData"
            :key="index"
          >
            <div class="order-header">
              <div style="color: #3b6bfb">订单号:{{ item.order_num }}</div>
              <div class="orderStatus" v-show="item.status == 1">待审核</div>
              <div class="orderStatus" v-show="item.status == 2 && status == 2">
                待确认
              </div>
              <div class="orderStatus" v-show="item.status == 3">待发货</div>
              <div class="orderStatus" v-show="item.status == 4">已发货</div>
              <div class="orderStatus" v-show="status == 5">已审核</div>
            </div>
            <div class="order-body" @click="goTeamDetails(item)">
              <div class="order-body-pic">
                <van-image :src="item.image"></van-image>
              </div>
              <div class="order-body-info">
                <div style="margin: 8px 0">
                  <div>{{ item.goods_name }}</div>
                  <div></div>
                </div>
                <div style="margin: 8px 0">
                  <div style="color: #999999">{{ item.attributes }}</div>
                  <div></div>
                </div>
                <div class="order-body-info-name">
                  <div style="color: #f95822">￥{{ item.price }}</div>
                  <div>*{{ item.nums }}</div>
                </div>
                 <div style="display:flex;justify-content:space-between">
                    <div></div>
                    <div>
                      快递:
                      {{ item.freight }}
                    </div>
                  </div>
                <!-- <div class="order-body-info-num">
                  <div></div>
                  <div>小计:￥{{ item.total_price }}</div>
                </div> -->
              </div>
            </div>
            <div class="order-body-info-num">
              <div>下单时间:{{ item.create_time }}</div>
              <div>小计:{{ item.total_price }}</div>
            </div>
            <div class="order-bottom">
              <!-- <van-button
                plain
                round
                @click="goTeamDetails(item)"
                class="getcolor"
                style="font-size: 12px"
                >点击订单详情,查看团队人员</van-button
              > -->
              <div @click="goTeamDetails(item)">点击订单详情,查看团队人员</div>
              <div class="itemBtn">
                <van-button
                  plain
                  round
                  class="orange-color"
                  @click="passTeam(item.id)"
                  v-if="item.status == 1"
                  >通过
                </van-button>
                <van-button
                  plain
                  round
                  class="red-color"
                  @click="cancelTeam(item.id)"
                  v-if="item.status == 1"
                  >拒绝
                </van-button>
                <van-button
                  plain
                  round
                  @click="submitTeam(item.id)"
                  v-if="item.status == 2 && status == 2"
                  class="getcolor"
                  >确认</van-button
                >
                <van-button
                  plain
                  round
                  class="red-color"
                  @click="refuseTeam(item.id)"
                  v-if="item.status == 2 && status == 2"
                  >拒绝</van-button
                >
                <!--   <van-button
                v-if="item.status == 0"
                plain
                round
                size="small"
                @click.stop="upImg( $router.push({ path: 'orderDetails',query:{id:item.id,active:active}}))"
                class="getcolor rightEl"
              >上传凭证</van-button> -->
              </div>
            </div>
          </div>
        </van-checkbox-group>
      </van-list>
    </div>
    <!-- <van-submit-bar button-text="支付" :price="allPrice*100" v-show="submitType" @submit="onSubmit" /> -->
    <van-dialog
      @confirm="submitpay"
      v-model="show"
      title="支付密码"
      show-cancel-button
    >
      <van-field
        type="password"
        v-model="pay_password"
        label="支付密码"
        placeholder="请输入支付密码"
      />
    </van-dialog>
  </div>
</template>
<script>
import { Dialog } from "vant";
import {
  ordersList,
  confirm,
  cancel,
  submit,
  orderVoucher,
  teamOrderList,
  submitNoPass,
} from "@/api/personal";
export default {
  data() {
    return {
      typeActive: 0,
      active: 0,
      result: [],
      show: false,
      pay_password: "",
      submitType: false,
      typeList: [
        { status: 0, label: "个人订单" },
        { status: 1, label: "团队订单" },
      ],
      arrTeam: [
        { status: 1, label: "待审核" },
        { status: 5, label: "已审核" },
        { status: 2, label: "待确认" },
        { status: 3, label: "待发货" },
        { status: 4, label: "已发货" },
      ],
      arrPersonal: [
        { status: 1, label: "进行中" },
        { status: 4, label: "已发货" },
        { status: 5, label: "已取消" },
      ],
      page: 1,
      status: 0,
      pagesize: 10,
      loading: false,
      finished: false,
      listData: [],
    };
  },
  computed: {
    allPrice: function () {
      let total = 0;
      this.listData.map((i, x) => {
        this.result.map((j, y) => {
          if (i.id == j) {
            total += parseInt(i.pay_money);
          }
        });
      });
      return total;
    },
  },
  created() {
    this.typeActive = Number(this.$route.query.typeActive) || 0;
    this.active = Number(this.$route.query.active) || 0;
    this.status = this.$route.query.status || 1;
    if (this.typeActive == 1 && this.active == 1) {
      this.status = 5;
    }
  },
  methods: {
    submitpay() {
      orderVoucher({
        ids: this.result.join(","),
        pay_password: this.pay_password,
      })
        .then((res) => {
          this.show = false;
          this.$toast("支付成功");
          this.result = [];
          this.active = 2;
          this.page = 1;
          this.listData = [];
          this.pay_password = "";
          this.status = 1;
          this.submitType = false;
          this.onLoad();
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    onSubmit() {
      this.show = true;
    },
    getresult(e) {
      // this.allPrice=0
      // this.listData.map((i,x)=>{
      //  e.map((j,y)=>{
      //   if(i.id==j){
      // 	 this.allPrice+= Number(i.pay_money)
      // 	 }
      //  })
      // })
      if (e.length > 0) {
        this.submitType = true;
      } else {
        this.submitType = false;
      }
    },
    changePerson(event, index) {
      this.index = index;
      this.page = 1;
      this.listData = [];
      this.status = event.status;
      this.onLoad();
    },
    changeTeam(event, index) {
      this.index = index;
      this.page = 1;
      this.listData = [];
      this.status = event.status;
      this.onLoadTeam();
    },
    changeType(event, index) {
      this.typeActive = index;
      this.page = 1;
      this.active = 0;
      this.listData = [];
      this.status = 1;
      if (this.typeActive == 0) {
        this.onLoad();
      } else {
        this.onLoadTeam();
      }
    },
    onLoadTeam() {
      this.$toast.loading({
        message: "加载中...",
        duration: 1500,
      });
      teamOrderList({
        status: this.status,
        page: this.page,
        pagesize: 10,
      }).then((res) => {
        this.listData = this.listData.concat(res.data);
        this.loading = false;
        if (this.listData.length >= res.count) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.page++;
      });
    },
    onLoad() {
      this.$toast.loading({
        message: "加载中...",
        duration: 1500,
      });
      ordersList({
        status: this.status,
        page: this.page,
        pagesize: 10,
      }).then((res) => {
        this.listData = this.listData.concat(res.data);
        this.loading = false;
        if (this.listData.length >= res.count) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.page++;
      });
    },
    // 个人
    goDetails(item) {
      this.$router.push({
        path: "orderDetails",
        query: { id: item.id },
      });
    },
    goTeamDetails(item) {
      this.$router.push({
        path: "orderTeamDetails",
        query: { id: item.id, type: this.status },
      });
    },
    passTeam(id) {
      Dialog.confirm({
        title: "",
        closeOnClickOverlay: true,
        message: "确定通过此团队订单？",
      })
        .then(() => {
          confirm({ id: id }).then((res) => {
            this.page = 1;
            this.listData = [];
            this.typeActive = 1;
            this.active = 0;
            this.status = 1;
            this.onLoadTeam();
          });
        })
        .catch(() => {});
    },
    cancelTeam(id) {
      Dialog.confirm({
        title: "",
        closeOnClickOverlay: true,
        message: "确定拒绝此团队订单？",
      })
        .then(() => {
          cancel({ id: id }).then((res) => {
            this.page = 1;
            this.listData = [];
            this.active = 0;
            this.typeActive = 1;
            this.status = 1;
            this.onLoadTeam();
          });
        })
        .catch(() => {});
    },
    submitTeam(id) {
      Dialog.confirm({
        title: "",
        closeOnClickOverlay: true,
        showCancelButton: false,
        message: "确认订单？",
      })
        .then(() => {
          submit({ id: id }).then((res) => {
            this.page = 1;
            this.$toast("确认成功!");
            this.listData = [];
            this.active = 3;
            this.typeActive = 1;
            this.status = 3;
            this.onLoadTeam();
          });
        })
        .catch(() => {});
    },
    refuseTeam(id) {
      Dialog.confirm({
        title: "",
        closeOnClickOverlay: true,
        showCancelButton: false,
        message: "拒绝审核该订单？",
      })
        .then(() => {
          submitNoPass(id).then((res) => {
            this.page = 1;
            this.$toast("拒绝成功!");
            this.listData = [];
            this.active = 2;
            this.typeActive = 1;
            this.status = 2;
            this.onLoadTeam();
          });
        })
        .catch(() => {});
    },
    onClickLeft() {
      this.$router.push({ path: "personal" });
    },
    // 取消订单
    stoporder(id) {
      Dialog.confirm({
        title: "取消订单",
        message: "确定取消此订单？",
      })
        .then(() => {
          cancelOrder(id).then((res) => {
            this.$toast("取消订单成功");
            this.page = 1;
            this.listData = [];
            this.onLoad();
          });
        })
        .catch(() => {
          this.$toast("取消操作");
        });
    },
  },
};
</script>
<style lang="less" scoped>
.wrap {
  height: 100vh;
}

.conWrap {
  margin-top: 30px;
  padding-bottom: 100px;
}

.carTop {
  width: 100%;
  height: 180px;
  background: url("../../assets/imgs/home/orderTop.png") 0 0 no-repeat;
  background-size: 100% 100%;

  .van-nav-bar {
    background: transparent;
    margin-bottom: 60px;
  }
}

[class*="van-hairline"]::after {
  border: 0 none;
}

/deep/ .van-tabs__nav {
  background: transparent;
}

/deep/ .van-tabs__line {
  background-color: #3b6bfb;
}

/deep/ .van-list {
  margin-top: 10px;
}

.order-item-wrapper {
  width: 90%;
  border-radius: 5px;
  background-color: #fff;
  font-size: 12px;
  margin: 20px auto;
  box-shadow: 0 0 3px rgba(94, 147, 238, 0.13);
  .order-header {
    height: 35px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0px 16.5px;
    font-size: 14px;
    width: 100%;

    .orderStatus {
      color: #ff6666;
      font-size: 16px;
    }
  }

  .order-body {
    box-sizing: border-box;
    display: flex;
    padding: 5px 12.5px 8px 12px;
    // border-bottom: 1px solid #e5e5e5;

    &-pic {
      width: 100px;
      height: 100px;
      margin-right: 11.5px;
      background-color: #f5f5f5;

      .van-image {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
    }

    &-info {
      width: 75%;

      &-name {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 12.5px;

        div:first-child {
          height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
      }
    }
  }

  .order-bottom {
    display: flex;
    justify-content: space-between;
    padding: 8px 12px;
    align-items: center;
    overflow: hidden;
    border-top: 1px solid #e5e5e5;

    &-ctr {
      .itemNum {
        color: #333;
        font-size: 12px;
      }

      .itemPrice {
        span:last-child {
          color: #de4f53;
          font-size: 18px;
        }
      }
    }
  }

  .itemBtn {
    color: #3b6bfb;
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/ .van-button {
      padding: 10px 20px;
      text-align: center;
      height: 30px;
      font-size: 12px;
      width: 68px;
      margin-left: 15px;
      border-radius: 15px;
    }
  }

  .getcolor {
    color: #3b6bfb;
    border: 1px solid #3b6bfb;
    background: none;
  }

  .orange-color {
    color: #fe9820;
    border: 1px solid #fe9820;
    background: none;
  }

  .red-color {
    color: red;
    border: 1px solid red;
    background: none;
  }
}

.order-body-info-num {
  display: block;
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-size: 12px;
  align-items: center;
  width: 100%;
  padding: 0 10px 10px;
  box-sizing: border-box;
}
</style>